import { connect, ConnectedProps } from 'react-redux';
import { fetchCards } from '../../../../actions/fetchCards';
import { selectDeviceType } from '../../../../selectors/deviceType';
import { IStoreState } from '../../../../types/StoreState';
import { FetchCardsErrorMessage } from './view';

const connector = connect(
  (state: IStoreState) => ({
    deviceType: selectDeviceType(state),
  }),
  {
    fetchCards,
  },
);

export type IFetchCardsErrorMessageConnectedProps = ConnectedProps<typeof connector>;
export const FetchCardsErrorMessageConnect = connector(FetchCardsErrorMessage);
